import Vue from 'vue';
import Vuex from 'vuex';
import { RootStoreState } from "@/store/RootStoreState";
import authenticationModule from "@/store/authenticationModule";
import questionnaireModule from "@/store/questionnaireModule";
import menuModule from "@/store/menuModule";
import toolModule from "@/store/toolModule";
import linkGovStore from './linkGovStore';
import localQuestionsStore from './localQuestionsTreatmentModule';
import resultStore from './ResultStore'; 


Vue.use(Vuex);

export default new Vuex.Store<RootStoreState>({
  state: {
    error: null,
    localQuestionsTreatment: {
      localQuestionsTreat: [], 
      initialized: false,
      initQuestion: false,
    }
  },
  getters: {
    hasError: state => state.error != null,
  },
  mutations: {
    error(state: RootStoreState, error: Error) {
      state.error = error;
    },
  },
  actions: {
    addError({commit}, error) {
      commit('error', error);
    },
    resetError({commit}) {
      commit('error', null);
    }
  },
  modules: {
    authentication: authenticationModule,
    questionnaire: questionnaireModule,
    menu: menuModule,
    tool: toolModule,
    linkGov: linkGovStore,
    localQuestionsTreatment: localQuestionsStore, 
    result: resultStore, 
  }
});
